import React, { useState } from 'react';
import PageLayout from '../components/PageLayout';
import { Mail, Send, CheckCircle } from 'lucide-react';

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;
    // Frontend-only demo: no backend wired yet.
    setSent(true);
    setTimeout(() => setSent(false), 5000);
    setForm({ name: '', email: '', message: '' });
  };

  return (
    <PageLayout>
      <section className="emi-wrap pt-8 pb-16">
        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-[#032D60] tracking-tight">Contact us</h1>
          <p className="mt-3 text-sm sm:text-base text-slate-600 dark:text-slate-400 max-w-3xl leading-relaxed">
            Questions, feedback or a feature request? We'd love to hear from you.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <form onSubmit={submit} className="lg:col-span-3 rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 space-y-4">
            <div>
              <label className="block text-xs font-semibold text-slate-600 uppercase tracking-wide mb-1">Name</label>
              <input
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                required
                className="w-full h-11 px-3 rounded-md border border-slate-200 dark:border-[#1E2A44] bg-white dark:bg-[#0F1B36] focus:border-[#0176D3] focus:ring-2 focus:ring-[#B7E1FA] outline-none text-sm"
                placeholder="Your full name"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-600 uppercase tracking-wide mb-1">Email</label>
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
                className="w-full h-11 px-3 rounded-md border border-slate-200 dark:border-[#1E2A44] bg-white dark:bg-[#0F1B36] focus:border-[#0176D3] focus:ring-2 focus:ring-[#B7E1FA] outline-none text-sm"
                placeholder="you@example.com"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-600 uppercase tracking-wide mb-1">Message</label>
              <textarea
                rows={5}
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                required
                className="w-full px-3 py-2 rounded-md border border-slate-200 dark:border-[#1E2A44] bg-white dark:bg-[#0F1B36] focus:border-[#0176D3] focus:ring-2 focus:ring-[#B7E1FA] outline-none text-sm resize-y"
                placeholder="How can we help?"
              />
            </div>
            <button
              type="submit"
              className="btn-3d inline-flex items-center gap-2 px-5 h-11 rounded-md bg-gradient-to-b from-[#0EA5FF] to-[#0176D3] hover:from-[#38BDF8] hover:to-[#014486] text-white text-sm font-semibold"
            >
              <Send className="h-4 w-4" /> Send message
            </button>

            {sent && (
              <div className="flex items-start gap-2 rounded-md bg-[#ECFDF5] border border-[#A7F3D0] px-3 py-2 text-sm text-[#065F46]">
                <CheckCircle className="h-4 w-4 mt-0.5" />
                Thanks! Your message has been queued (this is a frontend demo — no backend is wired yet).
              </div>
            )}
          </form>

          <aside className="lg:col-span-2 space-y-4">
            <div className="rounded-2xl border border-slate-200 bg-white p-6">
              <div className="h-10 w-10 rounded-lg bg-[#EAF5FE] text-[#0176D3] flex items-center justify-center">
                <Mail className="h-5 w-5" />
              </div>
              <h3 className="mt-3 text-base font-semibold text-[#032D60]">Email us</h3>
              <a href="mailto:hello@emiwise.app" className="mt-1 block text-sm text-[#0176D3] hover:underline">hello@emiwise.app</a>
              <p className="mt-2 text-xs text-slate-500 dark:text-slate-400 leading-relaxed">
                We typically reply within one business day.
              </p>
            </div>
          </aside>
        </div>
      </section>
    </PageLayout>
  );
}
